function track(event) {
    const { s, AnalyticsManager } = window;
    const { target, type, detail = { action: '' } } = event;

    if (!s) return;

    const trackData = {
        action: null,
        ctaButtonURL: null,
        ctaButtonCopy: null,
        moduleLocation: null,
        pagename: document.body.getAttribute('data-analytics-pagename'),
        section: 'Welcome',
        urlSlug: window.location.pathname.replace(/^\/|\/$/g, '')
    };

    const contextData = {
        ...AnalyticsManager.contextData,
        ...trackData
    };

    // s Top Level Items
    s.visitorID = 'D=s_vi';
    s.pageName = contextData.pagename;
    s.contextData = contextData;

    delete s.contextData.pagename;

    if (type.includes('click')) {
        const analyticsName = target.getAttribute('data-analytics-name') || '';
        const analyticsSection = target.getAttribute('data-analytics-section') || '';
        let moduleType = analyticsSection.includes(':') ? analyticsSection.split(':')[0].trim() : '';

        if (target.hasAttribute('data-analytics-module-type')) {
            moduleType = target.getAttribute('data-analytics-module-type');
        }

        s.contextData.action = `${trackData.pagename}: ${moduleType.charAt(0).toUpperCase() + moduleType.substr(1)} Click`;
        s.contextData.ctaButtonCopy = analyticsName;
        s.contextData.ctaButtonURL = target.href || '';
        s.contextData.moduleLocation = analyticsSection;

        // If the Optimizely custom integration is hooked up use it
        optimizelyIntegrationCall('trackDelayedCampaigns', s);

        s.tl(null, 'lnk_o', s.contextData.action);
    } else if (type.includes('event')) {

        s.contextData.action = `${trackData.pagename}: ${event.detail.action}`;

        // If the Optimizely custom integration is hooked up use it
        optimizelyIntegrationCall('trackDelayedCampaigns', s);

        s.tl(null, 'lnk_o', s.contextData.action);

    } else {

        // If the Optimizely custom integration is hooked up use it
        optimizelyIntegrationCall('assignCampaigns', s);

        s.t();

        if (window.optimizely) {
            window.optimizely.push({ type: 'sendEvents' });
        }

    }
}

/**
 * Currently Adobe Analytics only needs to listen for the click and load events
 */
export function initAdobeAnalytics() {
    document.addEventListener('analytics_click', track);
    document.addEventListener('analytics_load', track);
    document.addEventListener('analytics_event', track);
}


const optimizelyIntegrationCall = function (integrationAction, sVariable) {
    // If the Optimizely custom integration is hooked up use it
    const optimizelyIntegration = window.optimizely &&
        typeof window.optimizely.get === 'function' &&
        window.optimizely.get('custom/adobeIntegrator');

    if (optimizelyIntegration && optimizelyIntegration[integrationAction]) {
        optimizelyIntegration[integrationAction](sVariable);
    }
};
